<script setup lang="ts">
const props = defineProps<{
  post?: PostItem | null;
}>();

const { currentPalette } = useTheme();
</script>

<template>
  <section v-if="props.post?.author" class="post-author">
    <div class="post-author__container container">
      <div
        class="post-author__wrapper flex flex-col items-stretch gap-6 lg:gap-10"
      >
        <div class="post-author__title">
          <h2
            class="text-[2.5rem] leading-[2.5rem] lg:text-[3.125rem] lg:leading-[2.75rem]"
          >
            <span class="inline">Autor</span>
            <span class="inline tracking-[0.25rem]">&emsp14;</span>
            <span class="inline font-display tracking-[0.3125rem]"
              >artykułu</span
            >
          </h2>
        </div>

        <div
          class="post-author__content p-5 lg:p-10"
          :class="[currentPalette.bg]"
        >
          <div
            class="post-author__content-wrapper flex items-start justify-start gap-6 lg:gap-12"
          >
            <div
              v-if="props.post.author.image?.id"
              class="post-author__content-image min-w-12 basis-12 lg:min-w-12 lg:basis-[6.25rem] relative overflow-hidden aspect-square rounded-e-2xl rounded-b-2xl bg-white"
            >
              <NuxtPicture
                provider="directus"
                :src="
                  props.post.author.image.id +
                  (props.post.author.image.filename_download
                    ? '/' +
                      encodeURIComponent(
                        props.post.author.image.filename_download
                      )
                    : '')
                "
                width="100"
                height="100"
                class="block absolute inset-0 w-full h-full"
                :img-attrs="{
                  class: 'block absolute inset-0 w-full h-full object-cover',
                }"
                sizes="12vw xs:48px sm:79px md:95px lg:72px xl:100px xxl:138px"
                quality="65"
                :alt="props.post.author.name"
                preload
              />
            </div>

            <div class="post-author__content-text grow min-w-0">
              <div
                v-if="props.post.author.name"
                class="post-author__content-name"
              >
                <h3
                  class="text-lg leading-9 lg:text-2xl lg:leading-9 font-semibold"
                >
                  {{ props.post.author.name }}
                </h3>
              </div>

              <div
                v-if="props.post.author.role"
                class="post-author__content-role"
              >
                <p
                  class="text-sm leading-6 lg:text-base lg:leading-7 font-semibold"
                >
                  {{ props.post.author.role }}
                </p>
              </div>

              <div
                v-if="props.post.author.description"
                class="post-author__content-description mt-2"
              >
                <p class="text-sm leading-6 lg:leading-7 font-light">
                  {{ props.post.author.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
